import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RoleService } from "../../../modules/roles/components/role.service";
import { showNotification } from "../../../shared/utils/utils";

const roleService = new RoleService();

export const getRolesList = createAsyncThunk(
  "role/list",
  async (data: { params: any; body: any }, { rejectWithValue }) => {
    try {
      const response = await roleService.getRoles(data.params, data.body);
      return response.data;
    } catch (error: any) {
      showNotification(error.response.data.message, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

export const createRole = createAsyncThunk(
  "role/create",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await roleService.createRole(data);
      return response.data;
    } catch (error: any) {
      showNotification(error.response.data.message, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateRole = createAsyncThunk(
  "role/update",
  async (data: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await roleService.updateRole(data.id, data.body);
      return response.data;
    } catch (error: any) {
      showNotification(error.response.data.message, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "role/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await roleService.deleteRole(id);
      return response.data;
    } catch (error: any) {
      showNotification(error.response.data.message, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

export const getPermissions = createAsyncThunk(
  "role/permissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await roleService.getPermissions();      
      return response.data.data;
    } catch (error: any) {
      showNotification(error.response.data.message, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

export const getRoleCodes = createAsyncThunk(
  "role/getRoleCodes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await roleService.getRoleCodes();
      return response.data.data;
    } catch (error: any) {
      showNotification(error.response.data.message, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  loading: false,
  list: [],
  permissions: [],
  roleCodes: [],
  pagination: null,
  error: null,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRolesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRolesList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getRolesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as any;
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload;
      })
      .addCase(createRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRole.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createRole.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getRoleCodes.fulfilled, (state, action) => {
        state.roleCodes = action.payload;
      });
      
  },
});

export default roleSlice.reducer;